/* eslint no-underscore-dangle: 0 */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import debounce from "lodash.debounce";
import { scaleLinear } from "d3-scale";
import { Flex, Box } from "grid-styled";
import { Heading, Input, Button, Text, Slider, ButtonCircle } from "rebass";
import { FormattedMessage } from "react-intl";
import Immutable from "seamless-immutable";
import Select from "react-select";
import S from "string";
import localforage from "localforage";
import axios from "axios";
import Item from "../../components/Item/index";

const domains = scaleLinear()
  .domain([0, 100])
  .range([0, 100000]);

const CustomSlider = Slider.extend`
  background-color: ${props => (props.lw ? "#FACD00" : "fuchsia")};
  height: 16px;
  outline: none;
`;

const formatPrice = price => {
  if (price === 0) {
    return "0";
  }

  if (price === 100000) {
    return "100, 000";
  }

  const priceText = `${price}`;
  return `${priceText.substring(0, priceText.length - 3)}, ${priceText.substr(
    -3
  )}`;
};

const IS_PROD = process.env.NODE_ENV === "production";

const serverUrl = IS_PROD
  ? "https://milk-tea-foody.herokuapp.com/api"
  : "http://localhost:3000/api";

function computeStoreList(data) {
  return data
    .map(x => {
      const url = x._id;
      const name = S(
        url
          .slice(url.indexOf("vn") + 3)
          .split("-")
          .join(" ")
          .split("/")
          .join(" - ")
      ).capitalize().s;
      return {
        value: url,
        label: name
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}

class SearchForm extends Component {
  constructor(props) {
    super(props);
    const {
      // eslint-disable-next-line
      data,
      // eslint-disable-next-line
      match: { params }
    } = props;
    const { city, store, maxprice } = params;
    const selectedStore = store
      ? `https://www.now.vn/${city}/${store}`
      : undefined;

    const storeList = data ? computeStoreList(data) : [];
    this.state = Immutable({
      url: "",
      invalid: false,
      error: false,
      existingStore: false,
      serverUrl,
      data: data || undefined,
      dataSelected: undefined,
      dataFilteredSelected: undefined,
      storeList,
      selectedStore,
      searchMilktea: "",
      lowestPrice: 0,
      highestPrice: maxprice || 100000,
      shareLink: undefined
    });
    this.emitChangeDebouncedText = debounce(
      this.filterSelectedDataOnSearchText,
      1000
    );
    this.emitChangeDebouncedPrice = debounce(
      this.filterSelectedDataOnPrice,
      500
    );
  }

  componentDidMount = async () => {
    try {
      if (this.state.selectedStore && this.state.data) {
        let dataSelected;
        this.state.data.some(store => {
          if (store._id === this.state.selectedStore) {
            dataSelected = store.data;
            return true;
          }
          return false;
        });

        const dataFilteredSelected = Immutable(dataSelected);

        this.setState({
          dataSelected,
          dataFilteredSelected
        });

        this.filterSelectedDataOnPrice("highest", this.state.highestPrice);
      }

      const { data } = await axios.get(`${serverUrl}`);
      const retrievedData = await localforage.setItem("data", data.data);
      const storeList = computeStoreList(data.data);
      this.setState(() => ({
        storeList,
        data: retrievedData
      }));

      if (this.state.selectedStore && this.state.data) {
        let dataSelected;
        this.state.data.some(store => {
          if (store._id === this.state.selectedStore) {
            dataSelected = store.data;
            return true;
          }
          return false;
        });

        const dataFilteredSelected = Immutable(dataSelected);

        this.setState({
          dataSelected,
          dataFilteredSelected
        });

        this.filterSelectedDataOnPrice("highest", this.state.highestPrice);
      }
    } catch (error) {
      this.setState({
        error: true
      });
    }
  };
  componentWillUnmount() {
    this.emitChangeDebouncedText.cancel();
    this.emitChangeDebouncedPrice.cancel();
  }

  filterSelectedDataOnSearchText = value => {
    const dataFilteredSelected =
      this.state.dataSelected &&
      this.state.dataSelected.filter(x => {
        const latinName = S(x.name).latinise().s;
        const price = +x.price.split(",").join("");
        return (
          (latinName.match(new RegExp(`${value}`, "i")) ||
            x.name.includes(value)) &&
          price <= this.state.highestPrice &&
          price >= this.state.lowestPrice
        );
      });

    this.setState({
      dataFilteredSelected
    });
  };

  filterSelectedDataOnPrice = (type, value) => {
    let dataFilteredSelected;
    if (type === "highest") {
      dataFilteredSelected =
        this.state.dataSelected &&
        this.state.dataSelected.filter(x => {
          const latinName = S(x.name).latinise().s;
          const price = +x.price.split(",").join("");
          return (
            price <= value &&
            price >= this.state.lowestPrice &&
            (latinName.match(new RegExp(`${this.state.searchMilktea}`, "i")) ||
              x.name.includes(this.state.searchMilktea))
          );
        });
    } else {
      dataFilteredSelected =
        this.state.dataSelected &&
        this.state.dataSelected.filter(x => {
          const latinName = S(x.name).latinise().s;
          const price = +x.price.split(",").join("");
          return (
            price >= value &&
            price <= this.state.highestPrice &&
            (latinName.match(new RegExp(`${this.state.searchMilktea}`, "i")) ||
              x.name.includes(this.state.searchMilktea))
          );
        });
    }
    this.setState({
      dataFilteredSelected
    });
  };

  handleChangeMilktea = e => {
    const { value } = e.target;
    this.setState({
      searchMilktea: value
    });
    this.filterSelectedDataOnSearchText(value);
  };
  handleOnChangeUrl = e => {
    this.setState({
      url: e.target.value
    });
  };

  handleChangeStore = selectedOption => {
    const { value } = selectedOption || {};
    this.setState({ selectedStore: value });
    let dataSelected;
    this.state.data.some(store => {
      if (store._id === value) {
        dataSelected = store.data;
        return true;
      }
      return false;
    });

    const dataFilteredSelected = Immutable(dataSelected);

    this.setState({
      dataSelected,
      dataFilteredSelected
    });
  };

  handleChangeRangeLowest = ({ target: { value } }) => {
    const lowestPrice = Math.round(domains(value));
    this.setState({
      lowestPrice
    });

    this.filterSelectedDataOnPrice("lowest", value * 1000);
  };

  handleChangeRangeHighest = ({ target: { value } }) => {
    const highestPrice = Math.round(domains(value));
    this.setState({
      highestPrice
    });

    this.filterSelectedDataOnPrice("highest", value * 1000);
  };

  handleSubmit = async () => {
    this.setState(() => ({
      invalid: false,
      error: false,
      existingStore: false,
      url: ""
    }));

    const { url } = this.state;
    if (!url || !url.includes("http") || url.includes("?")) {
      this.setState({
        invalid: true
      });
    } else if (this.state.storeList.some(x => x.value === url)) {
      this.setState({
        existingStore: true
      });
    } else {
      const postData = {
        link: url
      };

      try {
        const { data } = await axios.post(this.state.serverUrl, postData);
        const storeList = computeStoreList([data]);
        const newData = await localforage.setItem(
          "data",
          this.state.data.concat(data)
        );
        this.setState(() => ({
          storeList: this.state.storeList.concat(storeList),
          data: newData
        }));
      } catch (error) {
        this.setState({
          error: true
        });
      }
    }
  };

  generateSharelink = () => {
    const { selectedStore, highestPrice } = this.state;
    // `https://www.now.vn/${location}/${store}`
    const link = selectedStore.substring(selectedStore.indexOf("vn") + 3);
    const [city, store] = link.split("/");
    // eslint-disable-next-line
    const shareLink = `${location.origin}/${city}/${store}/${highestPrice}`;
    this.setState({
      shareLink
    });
  };

  copyLinkToClipboard = () => {
    const textField = document.createElement("textarea");
    textField.innerText = this.state.shareLink;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  };

  render() {
    return (
      <Flex flexDirection="column" alignItems="center">
        {!IS_PROD && (
          <React.Fragment>
            <Box my={1}>
              <Heading textAlign="center" fontSize={[1, 2, 3, 4]}>
                <FormattedMessage id="heading" />
              </Heading>
            </Box>
            <Box>
              <Flex flexWrap="wrap" justifyContent="center">
                <Box mx={1}>
                  <FormattedMessage id="placeholder1">
                    {placeholder1 => (
                      <Input
                        value={this.state.url}
                        onChange={this.handleOnChangeUrl}
                        my={1}
                        mx={3}
                        fontSize={[0, 1, 2, 3]}
                        placeholder={placeholder1}
                      />
                    )}
                  </FormattedMessage>
                </Box>
              </Flex>
            </Box>
            <Box my={2} ml={36}>
              <Button
                onClick={this.handleSubmit}
                style={{ cursor: "pointer" }}
                fontSize={[1, 2, 3, 4]}
              >
                <FormattedMessage id="button" />
              </Button>
            </Box>
          </React.Fragment>
        )}
        <Box>
          <Text textAlign="center" color="red" fontSize={[0, 1, 2, 3]}>
            {this.state.invalid && <FormattedMessage id="invalidurl" />}
          </Text>
          <Text textAlign="center" color="red" fontSize={[0, 1, 2, 3]}>
            {this.state.error && <FormattedMessage id="interneterr" />}
          </Text>
          <Text textAlign="center" color="red" fontSize={[0, 1, 2, 3]}>
            {this.state.existingStore &&
              "The store already exist in our list below"}
          </Text>
        </Box>
        <Box width={[1 / 2, null, null, 1 / 3]}>
          <FormattedMessage id="select">
            {select => (
              <Select
                name="form-field-name"
                placeholder={select}
                value={this.state.selectedStore}
                onChange={this.handleChangeStore}
                options={this.state.storeList}
              />
            )}
          </FormattedMessage>
          <FormattedMessage id="milktea">
            {milktea => (
              <Input
                value={this.state.searchMilktea}
                onChange={this.handleChangeMilktea}
                style={{ border: "1px solid lightblue" }}
                my={2}
                placeholder={milktea}
              />
            )}
          </FormattedMessage>
          <FormattedMessage id="rangeLowest" />
          <Flex alignItems="center" flexDirection="column">
            <CustomSlider
              lw="true"
              my={3}
              defaultValue={0}
              onChange={this.handleChangeRangeLowest}
            />
            <Text mb={2} color="chocolate">
              {formatPrice(this.state.lowestPrice)} vnd
            </Text>
          </Flex>
          <FormattedMessage id="rangeHighest" />
          <Flex alignItems="center" flexDirection="column">
            <CustomSlider
              my={3}
              defaultValue={domains.invert(this.state.highestPrice)}
              onChange={this.handleChangeRangeHighest}
            />
            <Text mb={2} color="blue">
              {formatPrice(this.state.highestPrice)} vnd
            </Text>
          </Flex>
        </Box>
        <Box>
          <Flex flexWrap="wrap" justifyContent="center" alignItems="center">
            {this.state.dataFilteredSelected && (
              <FormattedMessage id="total">
                {total => (
                  <Flex flexDirection="column" alignItems="center">
                    <Flex mb={2} alignItems="baseline">
                      <Text mr={3}>
                        {total} {this.state.dataFilteredSelected.length}
                      </Text>
                      <ButtonCircle
                        style={{ cursor: "pointer" }}
                        onClick={this.generateSharelink}
                      >
                        <FormattedMessage id="shareLink">
                          {shareLink => shareLink}
                        </FormattedMessage>
                      </ButtonCircle>
                    </Flex>
                    {this.state.shareLink && (
                      <Flex flexDirection="column" alignItems="center" mb={2}>
                        <a target="_blank" href={this.state.shareLink}>
                          {this.state.shareLink}
                        </a>
                        <ButtonCircle
                          onClick={this.copyLinkToClipboard}
                          mt={3}
                          style={{ cursor: "pointer" }}
                        >
                          <FormattedMessage id="copyLink">
                            {copyLink => copyLink}
                          </FormattedMessage>
                        </ButtonCircle>
                      </Flex>
                    )}
                  </Flex>
                )}
              </FormattedMessage>
            )}
          </Flex>
          <Flex flexWrap="wrap" justifyContent="center" alignItems="center">
            {this.state.dataFilteredSelected &&
              this.state.dataFilteredSelected.map(value => (
                <Box key={value._id}>
                  <Item url={this.state.selectedStore} data={value} />
                </Box>
              ))}
          </Flex>
        </Box>
      </Flex>
    );
  }
}

export default withRouter(SearchForm);



// WEBPACK FOOTER //
// ./src/containers/SearchForm/index.js